<template>
  <div class="home"></div>
</template>

<script>

// Placeholder component to show the map for this route
export default {
  name: 'Home',
}

</script>
